import { FormItemButton } from '../types';
import { ContactFormButton } from './ContactFormButtonDefault';
import { ContactFormButtonConvoAI } from './ContactFormButtonConvoAI';

interface ContactFormButtonFactoryProps {
  item: FormItemButton;
  variant: 'default' | 'convoai';
  hasErrors: boolean;
  isValid: boolean;
  disabled: boolean;
  onClickCancel: () => void;
  isComplete: boolean;
}

export default function ContactFormButtonFactory({
  item,
  variant,
  hasErrors,
  isValid,
  disabled,
  onClickCancel,
  isComplete,
}: ContactFormButtonFactoryProps) {
  switch (variant) {
    case 'default':
      return (
        <ContactFormButton
          item={item}
          hasErrors={hasErrors}
          isValid={isValid}
          disabled={disabled}
        />
      );
    case 'convoai':
      if (isComplete) return null;
      return (
        <ContactFormButtonConvoAI
          item={item}
          hasErrors={hasErrors}
          isValid={isValid}
          disabled={disabled}
          onClickCancel={onClickCancel}
        />
      );
  }
}
